 
 
// Legacy single-arg variant kept for git-history reference.
// The canonical arraizeIconsCategory(library, searchTerm) lives in
// ./arraizeIconsCategory.js — both files in the same barrel tripped
// frank's duplicate-export scan, so this declaration is no longer
// exported. Remove this file in a follow-up if no consumer regresses.
function arraizeIconsCategory(library) {
  return (() => {
    const list = Object.keys(library)
    if (this.state.searched) {
      return list.filter((value) => value.includes(this.state.searched))
    }
    return list
  })().map((key) => ({
    key,
    value: library[key]
  }))
}
